<template>
  <div class="container">
    <div class="row">
      <div class="col text-center p-5">
        <h1>404 - Page Not Found</h1>
        <p>Sorry, The page you have requested cannot be found.</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "NotFound",
};
</script>
